const DATE_TIME = new Intl.DateTimeFormat('fr-FR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const DATE = new Intl.DateTimeFormat('fr-FR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

export function formatDateTime(iso: string | null): string {
  if (iso === null) return '—';
  return DATE_TIME.format(new Date(iso));
}

export function formatDate(iso: string | null): string {
  if (iso === null) return '—';
  return DATE.format(new Date(iso));
}

/** Une date sans heure arrive au format AAAA-MM-JJ et reste telle quelle. */
export function formatDateOnly(value: string | null): string {
  if (value === null || value === '') return '—';
  const [year, month, day] = value.split('-');
  if (year === undefined || month === undefined || day === undefined) return value;
  return `${day}/${month}/${year}`;
}

export function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}

function pad(value: number): string {
  return String(value).padStart(2, '0');
}

/** Valeur pour un champ <input type="datetime-local">, en heure locale. */
export function toDateTimeInput(iso: string): string {
  const date = new Date(iso);
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}

/** Instant ISO à partir d'un champ <input type="datetime-local"> local. */
export function fromDateTimeInput(value: string): string {
  return new Date(value).toISOString();
}

export function nowForInput(): string {
  return toDateTimeInput(new Date().toISOString());
}

export function fullName(person: { firstName: string; lastName: string }): string {
  return `${person.firstName} ${person.lastName}`.trim();
}
